import classNames from 'clsx';
import React, { memo, ReactElement, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { EStorageType } from 'reactApp/modules/storage/storage.types';
import { Link } from 'reactApp/ui/Link/Link';
import { noop } from 'reactApp/utils/helpers';

import styles from './MenuItem.css';

interface Props {
    id: string;
    title: string;
    icon?: ReactElement;
    storage: EStorageType;
    onClose: () => void;
}

export const MenuItem = memo(({ id, title, icon, storage, onClose }: Props): ReactElement => {
    const currentStorage = useSelector(getCurrentStorage);
    const isCurrent = currentStorage === storage && currentStorage !== EStorageType.subscriptions;

    const handleClick = useCallback(() => {
        onClose();
    }, [onClose]);

    return (
        <Link id={id} storage={storage} handleGoTo={noop} handleClick={handleClick}>
            <div onClick={handleClick} data-qa-item={id} className={classNames(styles.root, { [styles.root_active]: isCurrent })}>
                {icon && <div className={styles.icon}>{icon}</div>}
                <div className={styles.title}>{title}</div>
            </div>
        </Link>
    );
});

MenuItem.displayName = 'MenuItem';
